function AccessDenied() {
  return (
    <div className="content">You don't have permission to view this page.</div>
  );
}

export default AccessDenied;
